

















import { defineComponent, ref, watch } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'PageInfo',
  props: {
    currentCount: {
      type: Number,
      required: true,
    },
    totalCount: {
      type: Number,
      required: true,
    },
    isFetching: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const toggleFetch = ref(false);

    function onNext() {
      if (props.currentCount < props.totalCount) {
        emit('next');
      }
    }

    /***
     * watch on products isFetching state
     * if no products is being fetched and the user within observer range. Wait 2 seconds then:
     *  - fetch more products
     *
     */
    watch(
      () => props.isFetching,
      newValue => {
        if (toggleFetch.value && !newValue) {
          setTimeout(() => {
            onNext();
          }, 2000);
        }
      }
    );

    return {
      onNext,
      toggleFetch,
    };
  },
});
